import { createContext, useContext, useMemo, useState } from "react";

const HeaderActionsContext = createContext(null);

export function HeaderActionsProvider({ children }) {
  const [actions, setActions] = useState(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);
  return <HeaderActionsContext.Provider value={value}>{children}</HeaderActionsContext.Provider>;
}

export function useHeaderActions() {
  const ctx = useContext(HeaderActionsContext);
  if (!ctx) return { actions: null, setActions: () => {} };
  return ctx;
}
